var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrsdEmblemWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 80.592,
    viewBox: "0 0 100 80.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-1599.53 -529.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M403.331,112.042c.411.056.821.131,1.244.2a64.9,64.9,0,0,1,6.563-9.835,70.671,70.671,0,0,0-20.807-11.2Zm33.59,26.418-21.43-6.948,25.174,40.29a69.669,69.669,0,0,0-3.751-33.342Z",
    transform: "translate(1234.038 438.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M401.43,122.944c9.281-14.854,21.38-25.7,38.878-31.724l-25.174,40.3-25.174,40.29C387.707,153.425,392.149,137.8,401.43,122.944Z",
    transform: "translate(1234.397 438.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M350.4,127.351l26.779,8.709a96.242,96.242,0,0,1,8.74-4.273q.579-1.418,1.244-2.837c.728-1.586,1.512-3.11,2.326-4.616A81.121,81.121,0,0,0,350.4,127.351Zm73.221,8.709L400.4,143.6l50,16.248a80.822,80.822,0,0,0-26.779-23.806Z",
    transform: "translate(1249.13 425.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M350.4,159.841l28.577-9.287a77.586,77.586,0,0,1,3.583-8.192,68.336,68.336,0,0,1,3.359-10.575A82.519,82.519,0,0,0,350.4,159.841Zm62.161-35.705L400.4,143.606l50-16.242a80.984,80.984,0,0,0-37.839-3.228Z",
    transform: "translate(1249.13 425.916)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrsdEmblemWhite);
export default __webpack_public_path__ + "static/media/hrsd-emblem-white.ead2fe2720d3278527821806aed9dcfb.svg";
export { ForwardRef as ReactComponent };